import {getTimeOfDay, safeParse} from "../utils/date-formatters.mjs";
import { getAvailability, isSchoolBooking } from "../../services/performance.js";

let performanceData;

export default async function getPerformances() {
    if (performanceData) {
        return performanceData;
    }

    try {
        performanceData = fetch('/api/event-instances.json')
            .then(res => res.json())
            .then(data => processPerformances(data.docs));

        return performanceData;
    } catch (error) {
        console.error('Failed to load instances:', error);

        throw error;
    }
}

function firstFilled(...values) {
    return values.find(value => typeof value === 'string' && value.trim() !== '');
}

function processPerformances(performances) {
    const now = new Date();

    return performances
        .map(performance => {
            const startDate = safeParse(performance.startDateLocalAsUTC);

            performance.startDate = startDate;
            performance.timeOfDay = getTimeOfDay(startDate);

            if (AppConfig.boDomain) {
                performance.bookButton = {
                    title: 'Get Tickets',
                    link: `${AppConfig.boDomain.replace(/^\/|\/$/g, '')}/booking/production/${performance.tessitura.performanceId}`
                };
            } else if (AppConfig.tnewDomain) {
                performance.bookButton = {
                    title: 'Get Tickets',
                    link: (
                        isSchoolBooking(performance) ?
                        `${AppConfig.tnewDomain.replace(/^\/|\/$/g, '')}/c/schoolbooking?perfNo=${performance.tessitura.performanceId}` :
                        `${AppConfig.tnewDomain.replace(/^\/|\/$/g, '')}/${performance.tessitura.productionSeasonId}/${performance.tessitura.performanceId}`
                    )
                };
            } else {
                performance.bookButton = null;
            }

            const availability = getAvailability(performance);

            performance.isSoldOut = performance.bookingStatus === 'soldOut' || (availability !== null && availability <= 0);
            performance.isAvailabilityPending = !performance.bookingStatus && availability === null;

            performance.description = firstFilled(
                performance.description,
                performance.event.description,
            );

            const bookingLinkURL = firstFilled(
                performance.booking?.bookingLinkURL,
                performance.event.booking?.bookingLinkURL,
            );
            if (bookingLinkURL) {
                performance.bookButton = performance.bookButton || {};
                performance.bookButton.link = bookingLinkURL;
            }

            const bookingLinkLabel = firstFilled(
                performance.booking?.bookingLinkLabel,
                performance.bookingLabel,
                performance.event.booking?.bookingLinkLabel,
            );
            if (bookingLinkLabel && performance.bookButton) {
                performance.bookButton.title = bookingLinkLabel;
            }

            performance.performanceType = isSchoolBooking(performance) ?
                'school' :
                'public';

            performance.accessibility = [];

            if (performance.tessitura?.keywords?.length) {
                performance.accessibility = [].concat(
                    performance.accessibility,
                    performance.tessitura?.keywords?.filter(kw => kw.Category.Id === 10)    // "Ancillary Event" Category
                );
            }

            if (performance.tessitura?.keywords?.length) {
                performance.accessibility = [].concat(
                    performance.accessibility,
                    performance.tessitura?.keywords?.filter(kw => kw.Category.Id === 14)    // "Accessiblity Programs" Category
                );
            }

            performance.accessibility = performance.accessibility.map(kw => kw.Description.replace(/\s(Public|School)/, ''));

            return performance;
        })
        .filter(performance => performance.startDate >= now);
}
